import type { ReactNode } from 'react';
import classnames from 'classnames';

export type PopperMenuItemProps = {
  children: ReactNode | ReactNode[];
  onClick: () => void;
  isDisabled?: boolean;
  isWarning?: boolean;
  //  By default, after clicking something we click away so the menu will close.
  //  Passing shouldPersistMenuOnClick=true will skip this and leave the menu open.
  shouldPersistMenuOnClick?: boolean;
};

//  Clicks outside the dropdown in order to close it.
const simulateClickOutside = () => document.body.click();

/**
 * A clickable list item in a PopperMenu.
 *
 * @param {PopperMenuItemProps} props - PopperMenuItemProps props
 * @param {ReactNode | ReactNode[]} props.children - Contents of the menu item.
 * @param {() => void} props.onClick - Click handler which is fired when list item is clicked on.
 * @param {boolean} [props.isDisabled] - If the menu item is disabled.
 * @param {boolean} [props.isWarning] - Render the text in red, indicating the action will delete or remove something.
 */
const PopperMenuItem = ({
  children,
  onClick,
  isDisabled = false,
  isWarning = false,
  shouldPersistMenuOnClick,
}: PopperMenuItemProps) => (
  <li className="fossa-popper-menu__list__item">
    <button
      className={classnames('fossa-popper-menu__list__item__button', {
        'fossa-popper-menu__list__item__button--warning': isWarning,
      })}
      type="button"
      onClick={() => {
        onClick();
        if (!shouldPersistMenuOnClick) {
          simulateClickOutside();
        }
      }}
      disabled={isDisabled}
    >
      {children}
    </button>
  </li>
);

export default PopperMenuItem;
